<template>
  <div class="container no-margin">
    <number-input
      label="Celular"
      placeholder="Ej: 1143464800"
      subhint="Código de área y número, sin 0 y sin 15"
      accessibilityHint="Código de área y número, sin 0 y sin 15"
      v-model="value.numero"
      @input="handleInput"
      @onKeyPress="handleKeyPress"
      :name="name"
      :maxlength="'15'"
      :validationError="validationError"
      :disabled="loading"
      :loading="loading"
      :quantumObfuscate="quantumObfuscate"
      :required="required"
    />
  </div>
</template>

<script>
import bus from "@/bus";
import debounce from "lodash/debounce";
import NumberInput from "@/components/core/NumberInput";
import {
  DO_NORMALIZAR_NUMERO,
  DO_NORMALIZAR_CELULAR
} from "@/config/constants/action-types";
export default {
  name: "PhoneNumber",
  components: { NumberInput },
  props: {
    label: String,
    name: String,
    value: Object,
    analyticsTypology: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false,
      validationError: "",
      loading: false
    };
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getCelularNormalizado,
      celularNromalizado => {
        this.validationError =
          celularNromalizado.valido === false
            ? "No pudimos validar tu número, verificá que sea correcto"
            : "";
        bus.$emit("formValidate");
      },
      { immediate: true }
    );
  },
  methods: {
    checkValid() {
      this.checked = true;
      return this.value.normalizado.valido === true;
    },
    normalizarNumero() {
      if (this.value.numero.length >= 10) {
        this.loading = true;
        this.validationError = "";
        this.$store.dispatch(DO_NORMALIZAR_NUMERO, this.value.numero);
        this.loading = false;
      } else if (this.value.numero.length > 0) {
        this.$store.dispatch(DO_NORMALIZAR_CELULAR, {});
        this.validationError = "Número inválido";
      } else {
        this.validationError = "Tenés que ingresar este dato";
      }
    },
    handleInput: debounce(function() {
      bus.$emit("formValidate");
      this.normalizarNumero();
    }, 500),
    handleKeyPress() {
      this.$store.dispatch(DO_NORMALIZAR_CELULAR, { status: false });
      this.validationError = "Número inválido";
    }
  }
};
</script>
